var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partLoading"},[_c('div',[_c('div',{staticClass:"areaLoading"},[_c('van-loading',{attrs:{"size":"0.26rem","color":"#18bebb"}},[_c('span',{staticClass:"fontClass"},[_vm._v("加载中...")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }